exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a {\n    color: #4b4b4b;\n    text-decoration: none;\n}\n\n.footerLogo {\n    max-width: 33px;\n}\n\np {\n    color: #4b4b4b;\n}\n\nh2 {\n    font-weight: 400;\n    color: #4b4b4b;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /zeit/1e2f5901/src/app/footer/footer.component.css
// module id = ../../../../../src/app/footer/footer.component.css
// module chunks = main